import { createAsyncThunk } from '@reduxjs/toolkit'

import { ILocationData } from 'meta/pages/v4/location'
import { LocationController } from 'controller/location'

type Returned = ILocationData

type Props = {
  idOrCodeUrl: string
}

export const getData = createAsyncThunk<Returned, Props>('pages/location/data', async (props) => {
  const { idOrCodeUrl } = props

  return LocationController.getData({ idOrCodeUrl })
})
